var React = require('react');

function Social (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.61542 17.1H0V38H7.61542V17.1Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M28.5578 2.375C29.7953 0.931 31.7182 0 33.6982 0C37.2204 0 39.981 2.755 39.981 6.27C39.981 10.583 34.4407 15.58 28.5578 20.9C22.6749 15.561 17.1347 10.564 17.1347 6.27C17.1347 2.755 19.8953 0 23.4174 0C25.3974 0 27.3203 0.931 28.5578 2.375Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M36.1733 28.5H22.8463L18.8672 27.113L19.4955 25.327L22.8463 26.6H28.2151C29.4526 26.6 30.4617 25.593 30.4617 24.358C30.4617 23.427 29.8715 22.591 28.9957 22.249L15.1737 17.1H11.4231V34.238L24.7501 38L40 32.3C39.981 30.21 38.2865 28.5 36.1733 28.5Z","fill":"currentColor","key":2})]);
}

Social.defaultProps = {"width":"40","height":"38","viewBox":"0 0 40 38","fill":"none"};

module.exports = Social;

Social.default = Social;
